import Rete from 'rete'

import TextTemplate from './TextTemplate'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class TextComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.TEXT)

    this.data.component = TextTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !! window.xitFlowBuilderData.is_openai_addon_access
    this.isConditionAddonAvailable = !!window.xitFlowBuilderData.messenger_bot_condition
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.TEXT
    this.setConnection()

    const textInput = new Rete.Input(CONST_SOCKET.TEXT_INPUT, lang.text_socket_input_reply, this.socket.textInput, true)
    const textOutput = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT, lang.text_socket_output_next, this.socket.textOutput, false)
    const textOutputButton = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT_BUTTON, lang.text_socket_output_buttons, this.socket.textOutputButton, true)
    const textOutputQuickreply = new Rete.Output(CONST_SOCKET.TEXT_OUTPUT_QUICKREPLY, lang.text_socket_output_quick_replies, this.socket.textOutputQuickreply, true)

    node.addInput(textInput).addOutput(textOutput)
    
    // if (! instagram_addon) {
      //   node.addOutput(textOutputButton)
    // }
    
    node.addOutput(textOutputButton)
    node.addOutput(textOutputQuickreply)

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.TEXT_OUTPUT] = node.data
    outputs[CONST_SOCKET.TEXT_OUTPUT_BUTTON] = node.data
  }
  
  setConnection() {
    // Text may be connected to:
    this.socket.textOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.textOutput.combineWith(this.socket.openaiInput)
    this.socket.textOutput.combineWith(this.socket.carouselInput)
    this.socket.textOutput.combineWith(this.socket.imageInput)

    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.textOutput.combineWith(this.socket.conditionInput)
    }

    if (!this.isInstagramAddonAvailable) {
      this.socket.textOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.textOutput.combineWith(this.socket.videoInput)
      this.socket.textOutput.combineWith(this.socket.audioInput)
      this.socket.textOutput.combineWith(this.socket.fileInput)
      // this.socket.textOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.textOutput.combineWith(this.socket.rcnInput)

    this.socket.textOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.textOutput.combineWith(this.socket.ecommerceInput)
    this.socket.textOutput.combineWith(this.socket.componentListInput)

    if(this.http_api_module)
    {
      this.socket.textOutput.combineWith(this.socket.httpApiInput)
    }

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.textOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (Buttons): QuickReply, Buttons
    this.socket.textOutputButton.combineWith(this.socket.buttonInput)
    this.socket.textOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}